import React, { createContext, useContext, useState } from 'react';

const ChainsThemeContext = createContext();

export const useChainsTheme = () => {
  const context = useContext(ChainsThemeContext);
  if (!context) {
    throw new Error('useChainsTheme must be used within a ChainsThemeProvider');
  }
  return context;
};

export const ChainsThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false); // Default to light mode

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  const value = {
    isDarkMode,
    setIsDarkMode,
    toggleDarkMode
  };

  return (
    <ChainsThemeContext.Provider value={value}>
      {children}
    </ChainsThemeContext.Provider>
  );
}; 